import { connect } from "react-redux";
import { browserHistory } from "react-router";
import appPath from "utils/appPath";
import { SCREENS } from "common/constants/Constants";
import loginActions from "ducks/loginRegister";
import { setThinking, doneThinking } from "ducks/thinking";

export function createMapStateToProps() {
    return (state) => {
        const {
            loginRegister = {},
            thinking
        } = state;

        return {
            thinking,
            email: loginRegister.email,
            grecaptchaApiKey: state.config.grecaptchaApiKey,
            useRecaptcha: loginRegister.useRecaptcha,
            errors: loginRegister.errors,
            signInLink: appPath.withIframePrefix(SCREENS.SIGN_IN)
        };
    };
}

export function mapDispatchToProps(dispatch, ownProps) {
    return {
        onSubmit(email, captcha) {
            dispatch(loginActions.clearError("register"));
            dispatch(setThinking());

            return dispatch(loginActions.register(email, captcha, ownProps.location.query.redirectTo))
                .then(() => browserHistory.push(appPath.withIframePrefix(SCREENS.EMAIL_RESENT)))
                .then(() => dispatch(doneThinking()))
                .catch(() => dispatch(doneThinking()));
        }
    };
}

function createActivationEmailContainer(component) {
    return connect(
        createMapStateToProps(),
        mapDispatchToProps
    )(component);
}

export default createActivationEmailContainer;
